// Store 初始化与 APP 配置共用纯路径，避免读取尚未初始化的 api.ts 导出。
export const WORK_FLOW_SOP_INFO_PATH = '/workflow/sop/info.json';
